export const paymentFields = [
  'name_on_card',
  'card_number',
  'expiry_month',
  'expiry_year',
  'cvv',
  'account_name',
  'bsb_number',
  'account_number'
]

const toBase64 = bytes => btoa(String.fromCharCode(...new Uint8Array(bytes)))

export async function encryptBookingPayment(requestData, fetchKey) {
  const request = { ...requestData }
  const payment = {}
  paymentFields.forEach(field => {
    if (request[field] !== '' && request[field] != null) {
      payment[field] = String(request[field])
    }
    delete request[field]
  })
  delete request.payment_details
  if (!Object.keys(payment).length) return request

  if (!window.crypto || !window.crypto.subtle) {
    throw new Error('Payment encryption requires a secure HTTPS connection.')
  }
  const { key_id, public_key } = await fetchKey()
  const crypto = window.crypto
  const publicKeyBytes = Uint8Array.from(
    atob(public_key.replace(/-----[^-]+-----|\s/g, '')),
    char => char.charCodeAt(0)
  )
  const publicKey = await crypto.subtle.importKey(
    'spki',
    publicKeyBytes,
    // Match the server's PHP 7 OpenSSL OAEP implementation.
    { name: 'RSA-OAEP', hash: 'SHA-1' },
    false,
    ['encrypt']
  )
  const key = await crypto.subtle.generateKey(
    { name: 'AES-GCM', length: 256 },
    true,
    ['encrypt']
  )
  const iv = crypto.getRandomValues(new Uint8Array(12))
  const ciphertext = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv, tagLength: 128 },
    key,
    new TextEncoder().encode(JSON.stringify(payment))
  )
  const wrappedKey = await crypto.subtle.encrypt(
    { name: 'RSA-OAEP' },
    publicKey,
    await crypto.subtle.exportKey('raw', key)
  )
  request.payment_details = {
    version: 1,
    key_id,
    wrapped_key: toBase64(wrappedKey),
    iv: toBase64(iv),
    ciphertext: toBase64(ciphertext)
  }
  return request
}
